import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Slice } from 'prosemirror-model';
import { placeholderPlugin } from '../Placeholder';
import { v4 as uuidv4 } from 'uuid';
import { isBase64DataURL, getBlobFromDataURL, readAsDataURL, getFileExtensionByMimeType, processBase64Data } from '../../../../utils/helper.file';
import { isEmpty } from '../../../../utils/helper';
const IMAGE_FILE_FORMATS = ['image/png', 'image/jpeg', 'image/gif'];
const checkClipboardTypes = (type, item) => {
  const isDOMStringList = t => !t.indexOf && !!t.contains;
  return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
};
const isPastedFile = event => {
  const {
    clipboardData
  } = event;
  if (!clipboardData) {
    return false;
  }
  return checkClipboardTypes(clipboardData.types, 'Files');
};
const createMediaNode = (view, pos, type, name, url, thumbUrl) => {
  if (IMAGE_FILE_FORMATS.includes(type)) {
    const imgAttributes = {
      src: url,
      alt: name
    };
    if (url !== thumbUrl) imgAttributes['thumbUrl'] = thumbUrl;
    const imageNode = view.state.schema.nodes.image.create(imgAttributes);
    view.dispatch(view.state.tr.replaceWith(pos, pos, imageNode));
    view.state.tr.replaceSelectionWith(imageNode);
  } else {
    const mediaNode = view.state.schema.nodes.media.create({
      type,
      name,
      url,
      thumbUrl
    });
    view.dispatch(view.state.tr.replaceWith(pos, pos, mediaNode));
    view.state.tr.replaceSelectionWith(mediaNode);
  }
};
const getBinaryFiles = (items, files) => {
  let fileIndex = -1;
  return Promise.all(Object.keys(items).map(key => {
    const item = items[key];
    return new Promise(resolve => {
      if (item.kind !== 'file') {
        return resolve(null);
      }
      fileIndex += 1;
      const blob = item.getAsFile();
      const file = files[fileIndex];
      if (!blob || !file) {
        return resolve(null);
      }
      const reader = new FileReader();
      reader.addEventListener('error', () => resolve(null));
      reader.onload = response => {
        const dataUrl = response.target.result;
        return resolve({
          dataUrl,
          file
        });
      };
      return reader.readAsDataURL(blob);
    });
  })).then(binaryFiles => Promise.resolve(binaryFiles.filter(info => info)));
};
const isDroppedFile = event => {
  if (!event.dataTransfer) {
    return false;
  }
  return Array.prototype.slice.call(event.dataTransfer.types).indexOf('Files') !== -1;
};
const processFiles = (items, files, view, options) => {
  if (!options.onUpload && !options.allowUploadDataUrl) return;
  const placeholderId = Math.random();
  const {
    tr
  } = view.state;
  if (!tr.selection.empty) tr.deleteSelection();
  if (options.inline) {
    tr.setMeta(placeholderPlugin, {
      add: {
        id: placeholderId,
        pos: tr.selection.from
      },
      className: 'tap-image-loader'
    });
    view.dispatch(tr);
  }
  let pos = view.state.tr.selection.from;
  if (options && options.onUpload) {
    const filesList = Object.keys(files).map(key => files[key]);
    options.onUpload(filesList, uploadResponse => {
      view.dispatch(tr.setMeta(placeholderPlugin, {
        remove: {
          id: placeholderId
        }
      }));
      uploadResponse.forEach((info, index) => {
        if (options.inline) {
          const file = files[index];
          createMediaNode(view, pos, file.type, info.name, info.url, info.thumbUrl);
          pos += 1;
        } else {
          options.events.emit('addAttachment', {
            url: info.url,
            name: info.name,
            thumbUrl: info.thumbUrl
          });
        }
      });
    });
  } else {
    getBinaryFiles(items, files).then(binaryFiles => {
      view.dispatch(tr.setMeta(placeholderPlugin, {
        remove: {
          id: placeholderId
        }
      }));
      binaryFiles.forEach(info => {
        if (options.inline) {
          createMediaNode(view, pos, info.file.type, info.file.name, info.dataUrl, '');
          pos += 1;
        } else {
          options.events.emit('addAttachment', {
            url: info.dataUrl,
            name: info.file.name
          });
        }
      });
    });
  }
};
export const uploadFromClipboard = (view, event, options, activePlugins) => {
  if (!isPastedFile(event)) {
    return false;
  }

  // if (!activePlugins.includes('image')) {
  //   // Prevent paste events and return true to notify editor to not call any other paste event handlers
  //   event.preventDefault();
  //   event.stopPropagation();
  //   return true;
  // }

  event.preventDefault();
  event.stopPropagation();
  const clipboardData = event.clipboardData || event.originalEvent.clipboardData || {};
  const {
    items,
    files
  } = clipboardData;
  processFiles(items, files, view, options);
  return true;
};
export const uploadDroppedFiles = (view, event, options, activePlugins) => {
  if (!isDroppedFile(event)) {
    return false;
  }

  // if (!activePlugins.includes('image')) {
  //   // Prevent drop events and return true to notify editor to not call any other drop event handlers
  //   event.preventDefault();
  //   event.stopPropagation();
  //   return true;
  // }

  const {
    items,
    files
  } = event.dataTransfer;
  if (items) {
    event.preventDefault();
    event.stopPropagation();
    processFiles(items, files, view, options);
    return true;
  }
  return false;
};
const processPastedNodes = (nodes, event, options) => {
  if (!Array.isArray(nodes)) return nodes;
  const media = [];
  const newNodes = nodes.map(node => {
    if (node.type === 'image' || node.type === 'media') {
      const loaderId = uuidv4();
      media.push({
        loaderId,
        node
      });
      if (options && (options.onUpload || options.allowUploadDataUrl) && options.inline) {
        return {
          type: 'tap_loader',
          attrs: {
            id: loaderId
          }
        };
      } else {
        return {
          type: 'text',
          text: ' '
        };
      }
    } else if (isEmpty(node.content)) {
      return node;
    } else {
      const newNode = _objectSpread({}, node);
      const {
        media: subMedia,
        nodes: subNodes
      } = processPastedNodes(node.content, event, options);
      newNode.content = subNodes;
      media.push(...subMedia);
      return newNode;
    }
  });
  return {
    media,
    nodes: newNodes
  };
};
const createImageNode = function (view, url, thumbUrl, alt) {
  let title = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  const imgAttributes = {
    src: url,
    alt,
    title
  };
  if (url !== thumbUrl) imgAttributes['thumbUrl'] = thumbUrl;
  return view.state.schema.nodes.image.create(imgAttributes);
};
const getMediaNode = (view, type, name, url, thumbUrl) => {
  return view.state.schema.nodes.media.create({
    type,
    name,
    url,
    thumbUrl
  });
};
const fetchFileBlob = src => fetch(src, {
  cache: 'no-cache'
}).then(response => {
  if (response.ok) {
    return response.blob();
  }
  return Promise.reject('Failed to load file');
});
const uploadPastedFile = (fileInfo, view, options) => {
  const {
    node: {
      attrs: {
        name,
        src: imgSrc,
        url,
        alt,
        thumbUrl,
        type: fileType
      },
      type
    },
    loaderId
  } = fileInfo;
  const src = imgSrc || url;
  const DEFAULT_RESPONSE = Promise.resolve({
    loaderId
  });
  let fileName = name;
  const isDataUrl = isBase64DataURL(src);
  try {
    const {
      pathname = '',
      origin
    } = new URL(src);
    if (!isDataUrl && !options.allowedOrigins.includes(origin)) {
      return DEFAULT_RESPONSE;
    }
    if (!fileName) {
      if (isDataUrl) {
        const {
          mimeType
        } = processBase64Data(src);
        fileName = "File.".concat(getFileExtensionByMimeType(mimeType));
      } else {
        fileName = pathname.slice(pathname.lastIndexOf('/') + 1);
      }
    }
  } catch (err) {
    console.error(err);
    return DEFAULT_RESPONSE;
  }
  return (isDataUrl ? Promise.resolve(getBlobFromDataURL(src)) : fetchFileBlob(src)).then(fileBlob => {
    const fileObject = new File([fileBlob], fileName, {
      type: fileBlob.type
    });
    if (options && options.onUpload) {
      return new Promise(resolve => {
        options.onUpload([fileObject], uploadResponse => {
          const {
            name,
            url,
            thumbUrl
          } = uploadResponse[0];
          if (options.inline) {
            let replaceNode;
            if (type === 'image') {
              replaceNode = createImageNode(view, url || src, thumbUrl, alt, fileName);
            } else {
              replaceNode = getMediaNode(view, type, name, url, thumbUrl);
            }
            resolve({
              replaceNode,
              loaderId
            });
          } else {
            options.events.emit('addAttachment', {
              url: src,
              name: fileObject.name
            });
            resolve({
              loaderId
            });
          }
        });
      });
    } else if (options.allowUploadDataUrl) {
      return readAsDataURL(fileObject).then(dataUrl => {
        if (options.inline) {
          let replaceNode;
          if (type === 'image') {
            replaceNode = createImageNode(view, dataUrl, '', alt);
          } else {
            replaceNode = getMediaNode(view, type, fileObject.name, dataUrl, '');
          }
          return Promise.resolve({
            replaceNode,
            loaderId
          });
        } else {
          options.events.emit('addAttachment', {
            url: dataUrl,
            name: fileObject.name
          });
          return Promise.resolve({
            loaderId
          });
        }
      });
    }
    return Promise.resolve({
      loaderId
    });
  }).catch(err => {
    console.error(err);
    return Promise.resolve({
      loaderId
    });
  });
};
export const uploadPastedFiles = (view, event, options, content, restSlice) => {
  const {
    nodes: newContent,
    media
  } = processPastedNodes(content, event, options);
  const newSlice = Slice.fromJSON(view.state.schema, _objectSpread(_objectSpread({}, restSlice), {}, {
    content: newContent
  }));
  const {
    tr
  } = view.state;
  const newData = tr.replaceSelection(newSlice);
  view.dispatch(newData);
  Promise.all(media.map(mediaInfo => {
    return uploadPastedFile(mediaInfo, view, options);
  })).then(mediaInfos => {
    if (!options.inline) return Promise.resolve(null);
    const loaderPosMap = {};
    view.state.doc.descendants((node, pos) => {
      var _node$type;
      if ((node === null || node === void 0 || (_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) === 'tap_loader') {
        var _node$attrs;
        const loaderId = node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.id;
        loaderPosMap[loaderId] = pos;
      }
    });
    let newTr = view.state.tr;
    mediaInfos.toReversed().forEach(mediaInfo => {
      const {
        replaceNode,
        loaderId
      } = mediaInfo;
      const loaderPos = loaderPosMap[loaderId];
      if (!loaderPos) return;
      if (replaceNode) {
        newTr = newTr.replaceWith(loaderPos, loaderPos + 1, replaceNode);
      } else {
        newTr = newTr.delete(loaderPos, loaderPos + 1);
      }
    });
    view.dispatch(newTr);
  });
};